import tiersTypes from "./tiers.types";

export default {
  [tiersTypes.FETCH_TIERS_SUCCESS](state, payload) {
    state.type = tiersTypes.FETCH_TIERS_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [tiersTypes.FETCH_TIERS_FAILED](state, payload) {
    state.type = tiersTypes.FETCH_TIERS_FAILED;
    state.error = payload.error;
  },
  [tiersTypes.FETCH_TIERS_REQUEST](state) {
    state.type = tiersTypes.FETCH_TIERS_REQUEST;
    state.error = "";
  },
  [tiersTypes.ADD_TIER_SUCCESS](state) {
    state.type = tiersTypes.ADD_TIER_SUCCESS;
  },
  [tiersTypes.ADD_TIER_FAILED](state, payload) {
    state.type = tiersTypes.ADD_TIER_FAILED;
    state.error = payload.error;
  },
  [tiersTypes.ADD_TIER_REQUEST](state) {
    state.type = tiersTypes.ADD_TIER_REQUEST;
    state.error = "";
  },

  [tiersTypes.UPDATE_TIER_SUCCESS](state) {
    state.type = tiersTypes.UPDATE_TIER_SUCCESS;
  },
  [tiersTypes.UPDATE_TIER_FAILED](state, payload) {
    state.type = tiersTypes.ADD_TIER_FAILED;
    state.error = payload.error;
  },
  [tiersTypes.UPDATE_TIER_REQUEST](state) {
    state.type = tiersTypes.UPDATE_TIER_REQUEST;
    state.error = "";
  },

  [tiersTypes.DELETE_TIER_SUCCESS](state) {
    state.type = tiersTypes.DELETE_TIER_SUCCESS;
  },
  [tiersTypes.DELETE_TIER_FAILED](state, payload) {
    state.type = tiersTypes.DELETE_TIER_FAILED;
    state.error = payload.error;
  },
  [tiersTypes.DELETE_TIER_REQUEST](state) {
    state.type = tiersTypes.DELETE_TIER_REQUEST;
    state.error = "";
  }
};
